import React, { useState } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import * as Types from 'types'
import { Icon as DownIcon } from 'images/arrow-down.svg'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      Types.actionMenuItem,
      Types.actionMenuLink,
      Types.actionMenuExternalLink,
    ])
  ).isRequired,
  ariaLabel: PropTypes.string,
}

const defaultProps = {
  ariaLabel: 'View action items',
}

function ActionMenu({ items, ariaLabel }) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div className="action-menu">
      <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen} modal={false}>
        <DropdownMenu.Trigger asChild>
          <button
            type="button"
            className={classNames('button-primary', { open: isOpen })}
            aria-label={ariaLabel}
          >
            Actions
            <DownIcon />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            className="action-menu-dropdown-content"
            align="end"
            sideOffset={10}
          >
            {items.map((item) => {
              if (item.link) {
                return (
                  <DropdownMenu.Item
                    asChild
                    key={item.text}
                    className="menu-item"
                  >
                    <Link to={item.link}>{item.text}</Link>
                  </DropdownMenu.Item>
                )
              }
              if (item.externalLink) {
                return (
                  <DropdownMenu.Item
                    asChild
                    key={item.text}
                    className="menu-item"
                  >
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={item.externalLink}
                    >
                      {item.text}
                    </a>
                  </DropdownMenu.Item>
                )
              }
              return (
                <DropdownMenu.Item
                  key={item.text}
                  onSelect={item.handleSelect}
                  className="menu-item"
                >
                  {item.text}
                </DropdownMenu.Item>
              )
            })}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  )
}

ActionMenu.propTypes = exact(propTypes)
ActionMenu.defaultProps = defaultProps

export default React.memo(ActionMenu)
